module.exports = __webpack_public_path__ + "static/media/triangle.2ad2e701.svg";